module.exports = __webpack_public_path__ + "static/media/Fauzi.53abb71c.jpeg";